import { useEffect } from "react";

import { SITE_NAME, SITE_URL } from "@/content/siteContent";

const ensureMetaTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }

  return element;
};

const ensureLinkTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }

  return element;
};

export const usePageSEO = ({ title, description, canonicalPath = "/", keywords, noindex = false }) => {
  useEffect(() => {
    document.documentElement.lang = "it";
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

    const normalizedPath = canonicalPath === "/" ? "" : canonicalPath;
    const canonicalUrl = `${SITE_URL}${normalizedPath}`;
    const robotsContent = noindex ? "noindex,nofollow" : "index,follow";

    ensureMetaTag('meta[name="description"]', { name: "description" }).setAttribute("content", description);
    ensureMetaTag('meta[property="og:title"]', { property: "og:title" }).setAttribute(
      "content",
      title ? `${title} | ${SITE_NAME}` : SITE_NAME,
    );
    ensureMetaTag('meta[property="og:description"]', { property: "og:description" }).setAttribute(
      "content",
      description,
    );
    ensureMetaTag('meta[property="og:url"]', { property: "og:url" }).setAttribute("content", canonicalUrl);
    ensureMetaTag('meta[property="og:type"]', { property: "og:type" }).setAttribute("content", "website");
    ensureMetaTag('meta[property="og:site_name"]', { property: "og:site_name" }).setAttribute("content", SITE_NAME);
    ensureMetaTag('meta[name="twitter:title"]', { name: "twitter:title" }).setAttribute(
      "content",
      title ? `${title} | ${SITE_NAME}` : SITE_NAME,
    );
    ensureMetaTag('meta[name="twitter:description"]', { name: "twitter:description" }).setAttribute(
      "content",
      description,
    );
    ensureMetaTag('meta[name="robots"]', { name: "robots" }).setAttribute("content", robotsContent);
    ensureLinkTag('link[rel="canonical"]', { rel: "canonical" }).setAttribute("href", canonicalUrl);

    if (keywords) {
      ensureMetaTag('meta[name="keywords"]', { name: "keywords" }).setAttribute("content", keywords);
    }
  }, [canonicalPath, description, keywords, noindex, title]);
};
